module.exports = "<div>\n  <!-- <wx-navbar></wx-navbar> -->\n  <!-- <wx-sidebar :channelId=\"channelId\">\n  </wx-sidebar> -->\n  <router-view>loading...</router-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/views/client/client.html
// module id = ./src/views/client/client.html
// module chunks = 3